<script setup lang="ts">
import { ref } from 'vue';
import { fetchSsoOaTicket } from '@/service/api';

defineOptions({
  name: 'OaSwitch'
});

const oaSwitch = ref(false);
const oaSwitchLoading = ref(false);

async function goOa(value: boolean) {
  if (!value) {
    return;
  }

  oaSwitchLoading.value = true;
  try {
    const { data, error } = await fetchSsoOaTicket();
    if (!error && data?.url) {
      // 必须用浏览器跳转（302 + Cookie 流程），不能走 ajax
      window.location.href = data.url;
      return;
    }

    window.$message?.error('跳转OA工作台失败');
    oaSwitch.value = false;
    oaSwitchLoading.value = false;
  } catch (err: any) {
    window.$message?.error(err?.message || '跳转OA工作台失败');
    oaSwitch.value = false;
    oaSwitchLoading.value = false;
  }
}
</script>

<template>
  <div class="flex items-center">
    <div
      class="flex cursor-pointer items-center gap-2 border border-[#d0d3ff] rounded-full bg-[#eff0ff] px-3 py-1 transition-all dark:border-primary/30 dark:bg-primary/10"
      @click="!oaSwitchLoading && ((oaSwitch = true), goOa(true))"
    >
      <span class="select-none whitespace-nowrap text-xs text-[#636cff] font-medium dark:text-primary">跳转至OA</span>
      <NSwitch v-model:value="oaSwitch" :loading="oaSwitchLoading" size="small" @click.stop @update:value="goOa" />
    </div>
  </div>
</template>

<style scoped></style>
